<template>
  <div class="login">
    <div class="content">
      <!-- <div class="contentLeft">
        <el-image :src="require('./img/contentLeftImg.png')"/>
      </div> -->
      <div v-if="showAccountSign" class="contentRightA">
        <div class="upperRightCorner">
          <div class="upperRightCornerImg">
            扫码登录更便捷
          </div>
          <el-image
            :src="require('./img/QRcode.png')"
            @click="showAccountSign=false;showQRcodeSign=true;DrawQRCode('qrCodeBInterval')"/>
        </div>
        <div class="contentRightATitle"></div>
        <div class="contentRightAInput">
          <el-input v-model="username" placeholder="请输入手机号">
            <i slot="prefix" class="el-input__icon el-icon-user"/>
          </el-input>
        </div>
        <div class="contentRightAInput">
          <el-input v-model="code" type="text" placeholder="请输入验证码">
            <i slot="prefix" class="el-input__icon el-icon-lock"/>
            <div slot="suffix">
              <el-button class="contentRightAInputButton" :disabled="sendCode" @click="onSendCode">{{sendCode ? sendCodeText : "获取验证码"}}</el-button>
            </div>
          </el-input>
        </div>
        <div class="forgetPassword" @click="showAccountSign=false;forgetPassword=true">
          <!-- 忘记密码 -->
        </div>
        <div class="contentRightAButton">
          <el-button type="primary" @click="Sign">登录</el-button>
        </div>
        <!-- <div class="register">
          没有账号？<a
          @click="empty();showAccountSign=false;QRcodeRegister=true;DrawQRCode('qrCodeDInterval')">注册</a>
        </div> -->
      </div>
      <div v-if="showQRcodeSign" class="contentRightB">
        <div class="upperRightCorner">
          <div class="upperRightCornerImg">
            点击使用账号登录
          </div>
          <el-image :src="require('./img/account.png')" @click="showQRcodeSign=false;showAccountSign=true;MyClearInterval('qrCodeUrlB')"/>
        </div>
        <div class="contentRightBTitle"></div>
        <div class="contentRightBQRcode">
          <div class="contentRightBQRcodeTitle">微信扫码关注公众号完成登录</div>
          <div class="contentRightBQRcodeContent">
<!--            :logo-src="require('./img/account.png')" 二维码中间的图标-->
            <div v-if="invalid" class="invalid">二维码已失效</div>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
          </div>
          <div class="contentRightBQRcodeRefresh" @click="DrawQRCode('qrCodeBInterval')">点击刷新
            <el-icon class="el-icon-refresh-right"/>
          </div>
        </div>
      </div>
      <!-- <div v-if="accountRegister" class="contentRightC">
        <div class="upperRightCorner">
          <div class="upperRightCornerImg">
            扫码注册更便捷
          </div>
          <el-image
            :src="require('./img/QRcode.png')"
            @click="accountRegister=false;QRcodeRegister=true;DrawQRCode('qrCodeDInterval')"/>
        </div>
        <div class="contentRightCTitle">一云颁发</div>
        <div style="width: 100%;text-align: center;font-size: 14px;">注册账号</div>
        <div class="contentRightCInput">
          <el-input v-model="mobile" placeholder="请输入手机号码">
            <i slot="prefix" class="el-input__icon el-icon-user"/>
          </el-input>
        </div>
        <div class="contentRightCInput">
          <el-input v-model="code" placeholder="请输入验证码">
            <i slot="prefix" class="el-input__icon el-icon-message"/>
            <el-button slot="suffix" :disabled="codeButtonText!=='获取验证码'" @click="getCode(0)">
              {{ codeButtonText }}
            </el-button>
          </el-input>
        </div>
        <div class="contentRightCInput">
          <el-input v-model="password" :type="flag_register?'text':'password'" placeholder="请输入密码" auto-complete="new-password">
            <i slot="prefix" class="el-input__icon el-icon-lock"/>
            <i slot="suffix" :class="[flag_register?'el-icon-view':'el-icon-minus']" class="el-input__icon" style="cursor: pointer" @click="flag_register=!flag_register"/>
          </el-input>
        </div>
        <div class="contentRightCButton">
          <el-button type="primary" @click="MyRegister">注册</el-button>
        </div>
        <div class="register">
          已有账号<a
          @click="empty();accountRegister=false;showQRcodeSign=true;DrawQRCode('qrCodeBInterval')">登录</a>
        </div>
      </div>
      <div v-if="QRcodeRegister" class="contentRightD">
        <div class="upperRightCorner">
          <div class="upperRightCornerImg">
            点击使用手机注册
          </div>
          <el-image :src="require('./img/account.png')" @click="QRcodeRegister=false;accountRegister=true;MyClearInterval('qrCodeUrlD')"/>
        </div>
        <div class="contentRightDTitle">一云颁发</div>
        <div class="contentRightDQRcode">
          <div class="contentRightDQRcodeTitle">微信扫码关注公众号完成注册</div>
          <div class="contentRightDQRcodeContent">
            <div v-if="invalid" class="invalid">二维码已失效</div>
            <vue-qr ref="qrCodeUrlD" :size="qrCode.size" :margin="qrCode.margin" :text="qrCode.text" />
          </div>
          <div class="contentRightDQRcodeRefresh" @click="DrawQRCode('qrCodeDInterval')">点击刷新
            <el-icon class="el-icon-refresh-right"/>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="forgetPassword" class="contentRightE">
        <div class="upperRightCorner">
          <div class="upperRightCornerImg">
            点击使用账号登录
          </div>
          <el-image
            :src="require('./img/account.png')"
            @click="forgetPassword=false;showAccountSign=true"/>
        </div>
        <div class="contentRightETitle">一云颁发</div>
        <div style="width: 100%;text-align: center;font-size: 14px;">忘记密码</div>
        <div class="contentRightEInput">
          <el-input v-model="mobile" placeholder="请输入手机号码">
            <i slot="prefix" class="el-input__icon el-icon-user"/>
          </el-input>
        </div>
        <div class="contentRightEInput">
          <el-input v-model="code" placeholder="请输入验证码">
            <i slot="prefix" class="el-input__icon el-icon-message"/>
            <el-button slot="append" :disabled="codeButtonText!=='获取验证码'" @click="getCode(1)">
              {{ codeButtonText }}
            </el-button>
          </el-input>
        </div>
        <div class="contentRightEInput">
          <el-input v-model="password" :type="flag_register?'text':'password'" placeholder="请输入密码" auto-complete="new-password">
            <i slot="prefix" class="el-input__icon el-icon-lock"/>
            <i slot="suffix" :class="[flag_register?'el-icon-view':'el-icon-minus']" class="el-input__icon" style="cursor: pointer" @click="flag_register=!flag_register"/>
          </el-input>
        </div>
        <div class="contentRightEButton">
          <el-button type="primary" @click="MyReset">修改密码</el-button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

// import loginIn from '../../api/common_api'
// import userInfo from '@/api/system_api'
// import VueQr from 'vue-qr'
import QRCode from "qrcodejs2";
import { getWxCode, sendCode, wxLogin, loginByCode } from '@/api/price'
import { Message } from 'element-ui'

export default {
  components: {
    // VueQr
    Message
  },
  
  watch: {
    showQRcodeSign: {
      handler() {
        if (this.showQRcodeSign) {
          this.timer = setInterval(async () => {
            let res = await wxLogin(
              { state: this.codeData.state },
            );
            if (!res.payload.retry && !res.payload.expired) {
              clearInterval(this.timer);
              res.payload = res.payload.token;
              this.messg(res);
            }
          }, 3000);
        } else {
          clearInterval(this.timer);
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      timer: null,
      mobile: '',
      account: '',
      password: '',
      code: '',
      codeButtonText: '获取验证码',
      showAccountSign: false,
      showQRcodeSign: true,
      accountRegister: false,
      QRcodeRegister: false,
      forgetPassword: false,
      flag: false,
      flag_register: false,
      invalid: false,
      qrCode: {
        text: '',
        size: 210,
        margin: 0
      },
      qrCodeBInterval: 0,
      qrCodeDInterval: 0,
      codeData: {
        exptime: -1,
      },
      username: '',
      password: '',
      sendCode: false,
      time: 60,
      sendCodeText: '获取验证码',
    }
  },
  created() {
    this.DrawQRCode('qrCodeUrlB')
  },
  methods: {
    async Sign() {
      if (this.username === '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return
      }
      // 校验手机号
      if (!(/^1[3456789]\d{9}$/.test(this.username))) {
        this.$message({
          message: '手机号格式不正确',
          type: 'error'
        })
        return
      }
      if (this.code === '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }

      const res = await loginByCode({ mobile: this.username, code: this.code })
      this.messg(res);

    },
    MyRegister() {
      if (this.mobile === '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return
      } else if (this.mobile.length !== 11) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      if (this.code === '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      if (this.password === '') {
        this.$message({
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      loginIn.checkCode({
        mobile: this.mobile,
        code: this.code
      }).then((res) => {
        if (res.s === 1) {
          loginIn.register({
            mobile: this.mobile,
            passWord: this.password
          }).then((res) => {
            if (res.s === 1) {
              this.$message({
                message: '注册成功',
                type: 'success'
              })
              loginIn.toindex({
                action: 'localLogin',
                userName: this.mobile,
                password: this.password
              }).then((res) => {
                if (res.s === 1) {
                  this.$router.push({
                    path: '/'
                  })
                }
              })
            }
          })
        }
      })
    },
    MyReset() {
      if (this.mobile === '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return
      } else if (this.mobile.length !== 11) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      if (this.code === '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      if (this.password === '') {
        this.$message({
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      loginIn.checkCode({
        mobile: this.mobile,
        code: this.code
      }).then((res) => {
        if (res.s === 1) {
          loginIn.resetPwd({
            mobile: this.mobile,
            passWord: this.password
          }).then((res) => {
            if (res.s === 1) {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              loginIn.toindex({
                action: 'localLogin',
                userName: this.mobile,
                password: this.password
              }).then((res) => {
                if (res.s === 1) {
                  this.$router.push({
                    path: '/'
                  })
                }
              })
            }
          })
        }
      })
    },
    getCode(sendCodeFor) {
      if (this.mobile === '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return
      } else if (this.mobile.length !== 11) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
        return
      }
      loginIn.sendCode({
        mobile: this.mobile,
        sendCodeFor: sendCodeFor
      }).then((res) => {
        if (res.s === 1) {
          Message({
            message: '验证码发送成功',
            type: 'success',
            customClass: 'global-messageZindex'
          })
          let time = 60
          this.codeButtonText = time + '秒后重发'
          const intervalTime = setInterval(() => {
            time = time - 1
            this.codeButtonText = time + '秒后重发'
            if (time === 0) {
              clearInterval(intervalTime)
              this.codeButtonText = '获取验证码'
            }
          }, 1000)
        }
      })
    },
    async DrawQRCode(name) {
      const res = await getWxCode()
      if (res.code === 1) {
        this.codeData = res.payload;
        this.$nextTick(() => {
          this.closeCode();
          setTimeout(() => {
            this.crateQrcode();
          }, 50);
        });
      }

    },

    crateQrcode() {
      this.closeCode();
      this.qr = new QRCode("qrcode", {
        width: 210,
        height: 210, // 高度
        text: this.codeData.url, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
    },

    closeCode() {
      this.$refs.qrcode.innerHTML = "";
    },

    async onSendCode() {
      console.log(this.username);
      if (this.username) {
        this.sendTime = true;
        let res = await sendCode(
          { number: this.username },
        );
        if (res.code === 1) {
          this.$message({
            message: "验证码发送成功",
            type: "success",
            customClass: 'global-messageZindex'
          });
          this.sendTime = false;
          this.sendCode = true;
          this.sendCodeText = "60s后重发";
          this.sendCodeTime = setInterval(() => {
            this.sendCodeText = this.sendCodeText.replace(/\d+/, (num) => {
              if (num > 1) {
                num--;
                return num;
              } else {
                this.sendCode = false;
                this.sendCodeText = "获取验证码";
                clearInterval(this.sendCodeTime);
                return num;
              }
            });
          }, 1000);
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } else {
        Message.error("请输入手机号");
      }
    },

    messg(res) {
      if (res.code === 1) {
        localStorage.setItem("token", res.payload);
        this.$emit("login", true);
        this.username = "";
        this.code = "";
      } else {
        Message({
          message: res.msg,
          type: "error",
          customClass: 'global-messageZindex'
        })
      }
    },

    MyClearInterval(name) {
      clearInterval(this[name])
    },
    empty() {
      this.mobile = ''
      this.account = ''
      this.password = ''
      this.code = ''
    },
    cycleValidation(state, name) {
      return setInterval(() => {
        loginIn.validate({ state: state }).then((res) => {
          if (res.s === 1) {
            switch (res.d) {
              case 'CONTINUE':
                // 继续等待
                break
              case 'DONE':
                // 完成验证
                clearInterval(this[name])
                userInfo.fetchUser().then(resd=>{
                    this.userList=resd.d
                    localStorage.setItem("userList",JSON.stringify(resd.d))
                    localStorage.setItem("dl",true)
                    this.$router.push({
                      path: '/'
                    })
                    
                })
                break
              case 'ORIGIN':
                // 完成第一次登陆验证
                clearInterval(this[name])
                userInfo.fetchUser().then(resd=>{
                  this.userList=resd.d
                  console.log(resd.d,'resd.d')
                  localStorage.setItem("userList",JSON.stringify(resd.d))
                  localStorage.setItem("dl",true)
                  console.log('first')
                  this.$router.push({
                    path: '/',
                    query:{
                      content:'first'
                    }
                  })
                })
                
                break
              case 'EXPIRED':
                // 二维码过期
                clearInterval(this[name])
                this.invalid = true
                break
            }
          }
        })
      }, 1000)
    }
  }
}
</script>

<style lang="less">

::v-deep .el-dialog__body {
  padding-top: 0px !important;
}

.global-messageZindex {
  z-index:10000 !important;
}

.login {
  width: 100%;
  padding: 0 0 15px;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login .content {
  max-width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url("img/contentBackground.png"); */
  background-size: 100% 100%;
  padding: 0 18px;
}

.login .content .contentLeft {
  width: 620px;
  height: 538px;
  display: flex;
  align-items: center;
}

.login .content .contentLeft img {
  width: 624px;
  height: 506px;
  margin-left: 18px;
}

.login .content .contentRightA {
  width: 420px;
  height: 370px;
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 4px;
}

.login .content .contentRightA .upperRightCorner {
  width: 185px;
  height: 74px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
}

.login .content .contentRightA .upperRightCorner .upperRightCornerImg {
  font-family: sans-serif;
  width: 107px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3984f5;
  text-align: center;
  background-image: url("img/upperRightCornerImg.png");
  background-size: 100% 100%;
}

.login .content .contentRightA .upperRightCorner img {
  cursor: pointer;
}

.login .content .contentRightA .contentRightATitle {
  width: 100%;
  font-size: 26px;
  margin-top: 30px;
  margin-bottom: 72px;
}

.login .content .contentRightA .contentRightAInput {
  margin-top: 10px;
}

.login .content .contentRightA .contentRightAInput .el-input {
  width: 340px;
  height: 40px;
  margin-right: 52px;
}

.login .content .contentRightA .contentRightAInput input {
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
}

.login .content .contentRightA .forgetPassword {
  font-size: 14px;
  margin-top: 10px;
  margin-right: 52px;
  color: #999999;
  cursor: pointer;
}

.login .content .contentRightA .contentRightAButton {
  margin-right: 52px;
  margin-top: 26px;
}

.login .content .contentRightA .contentRightAButton button {
  width: 338px;
  background-color: #008aee;
  font-size: 16px;
  height: 48px;
}

.login .content .contentRightA .register {
  font-size: 14px;
  margin-top: 20px;
  margin-right: 52px;
  color: #191919;
}

.login .content .contentRightA .register a {
  color: #1989ff;
  cursor: pointer;
}

.login .content .contentRightB {
  width: 420px;
  height: 370px;
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.login .content .contentRightB .upperRightCorner {
  width: 185px;
  height: 74px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
}

.login .content .contentRightB .upperRightCorner .upperRightCornerImg {
  width: 107px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3984f5;
  text-align: center;
  background-image: url("img/upperRightCornerImg.png");
  background-size: 100% 100%;
}

.login .content .contentRightB .upperRightCorner img {
  cursor: pointer;
}

.login .content .contentRightB .contentRightBTitle {
  width: 100%;
  font-size: 26px;
  margin-top: 30px;
  margin-bottom: 52px;
}

.login .content .contentRightB .contentRightBQRcode {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.login .content .contentRightB .contentRightBQRcode .contentRightBQRcodeTitle {
  margin-bottom: 20px;
  color: #191919;
  font-size: 14px
}

.login .content .contentRightB .contentRightBQRcode .contentRightBQRcodeContent {
  width: 210px;
  height: 210px;
  position: relative
}

.login .content .contentRightB .contentRightBQRcode .contentRightBQRcodeContent .invalid{
  position: absolute;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.70);
  display: flex;
  justify-content: center;
  align-items: center
}

.login .content .contentRightB .contentRightBQRcode .contentRightBQRcodeRefresh {
  margin-top: 20px;
  color: #999999;
  font-size: 14px;
  cursor: pointer;
}

.login .content .contentRightC {
  width: 420px;
  height: 498px;
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.login .content .contentRightC .upperRightCorner {
  width: 185px;
  height: 74px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
}

.login .content .contentRightC .upperRightCorner .upperRightCornerImg {
  width: 107px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3984f5;
  text-align: center;
  background-image: url("img/upperRightCornerImg.png");
  background-size: 100% 100%;
}

.login .content .contentRightC .upperRightCorner img {
  cursor: pointer;
}

.login .content .contentRightC .contentRightCTitle {
  width: 100%;
  font-size: 26px;
  margin-top: 72px;
  margin-bottom: 52px;
}

.login .content .contentRightC .contentRightCInput {
  margin-top: 10px;
}

.login .content .contentRightC .contentRightCInput .el-input {
  width: 340px;
  margin-right: 52px;
}

.login .content .contentRightC .contentRightCInput input {
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
}

.login .content .contentRightC .contentRightCInput .el-input__suffix button {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  color: #1989ff;
}

.login .content .contentRightC .contentRightCInput .el-input-group__append .el-button.is-disabled {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
  color: #999999;
}

.login .content .contentRightC .contentRightCButton {
  margin-right: 52px;
  margin-top: 26px;
}

.login .content .contentRightC .contentRightCButton button {
  width: 338px;
  background-color: #008aee;
  font-size: 16px;
  height: 48px;
}

.login .content .contentRightC .register {
  font-size: 14px;
  margin-top: 20px;
  color: #191919;
  width: 100%;
  text-align: center;
}

.login .content .contentRightC .register a {
  color: #1989ff;
  cursor: pointer;
}

.login .content .contentRightD {
  width: 420px;
  height: 498px;
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.login .content .contentRightD .upperRightCorner {
  width: 185px;
  height: 74px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
}

.login .content .contentRightD .upperRightCorner .upperRightCornerImg {
  width: 107px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3984f5;
  text-align: center;
  background-image: url("img/upperRightCornerImg.png");
  background-size: 100% 100%;
}

.login .content .contentRightD .upperRightCorner img {
  cursor: pointer;
}

.login .content .contentRightD .contentRightDTitle {
  width: 100%;
  font-size: 26px;
  margin-top: 72px;
  margin-bottom: 52px;
}

.login .content .contentRightD .contentRightDQRcode {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.login .content .contentRightD .contentRightDQRcode .contentRightDQRcodeTitle {
  margin-bottom: 20px;
  color: #191919;
  font-size: 14px
}

.login .content .contentRightD .contentRightDQRcode .contentRightDQRcodeContent {
  width: 210px;
  height: 210px;
  position: relative;
}

.login .content .contentRightD .contentRightDQRcode .contentRightDQRcodeContent .invalid{
  position: absolute;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.70);
  display: flex;
  justify-content: center;
  align-items: center
}

.login .content .contentRightD .contentRightDQRcode .contentRightDQRcodeRefresh {
  margin-top: 20px;
  color: #999999;
  font-size: 14px;
  cursor: pointer;
}

.login .content .contentRightE {
  width: 420px;
  height: 498px;
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.login .content .contentRightE .upperRightCorner {
  width: 185px;
  height: 74px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
}

.login .content .contentRightE .upperRightCorner .upperRightCornerImg {
  width: 107px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3984f5;
  text-align: center;
  background-image: url("img/upperRightCornerImg.png");
  background-size: 100% 100%;
}

.login .content .contentRightE .upperRightCorner img {
  cursor: pointer;
}

.login .content .contentRightE .contentRightETitle {
  width: 100%;
  font-size: 26px;
  margin-top: 72px;
  margin-bottom: 52px;
}

.login .content .contentRightE .contentRightEInput {
  margin-top: 10px;
}

.login .content .contentRightE .contentRightEInput .el-input {
  width: 340px;
  margin-right: 52px;
}

.login .content .contentRightE .contentRightEInput input {
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
}

.login .content .contentRightE .contentRightEInput .el-input-group__append {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
  color: #1989ff;
}

.login .content .contentRightE .contentRightEInput .el-input-group__append .el-button.is-disabled {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  border-bottom-width: 1px;
  color: #999999;
}

.login .content .contentRightE .contentRightEButton {
  margin-right: 52px;
  margin-top: 26px;
}

.login .content .contentRightE .contentRightEButton button {
  width: 338px;
  background-color: #008aee;
  font-size: 16px;
  height: 48px;
}

.contentRightAInputButton {
  height: 30px;
  width: 90px;
  margin-top: 5px;
  line-height: 0px;
  display: flex;
  justify-content: center;
  padding: 0 !important;
  align-items: center;
}

::deep .el-button {
  width: 90px !important;
  
}

</style>
